import { render, staticRenderFns } from "./telecomTemplateEdit.vue?vue&type=template&id=38c424f3&scoped=true"
import script from "./telecomTemplateEdit.vue?vue&type=script&lang=js"
export * from "./telecomTemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./telecomTemplateEdit.vue?vue&type=style&index=0&id=38c424f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c424f3",
  null
  
)

export default component.exports